export default function Footer() {
  const year = new Date().getFullYear();
  const anchors = [
    { id: "trend", label: "热榜趋势" },
    { id: "news", label: "资讯精选" },
    { id: "columns", label: "深度长文" },
    { id: "stars", label: "明星人物" },
    { id: "faq", label: "常见问题" },
    { id: "about", label: "关于本站" },
  ];
  return (
    <footer className="bg-ink-950 text-white">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}>
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-crimson-500 text-lg text-white">
                <i className="ri-star-fill" aria-hidden="true"></i>
              </span>
              <span className="font-serif text-xl font-black">
                明星<span className="text-crimson-400">爆料</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
              聚合公开娱乐报道，按剧集、音乐、红毯与行业话题分类呈现。只做可溯源内容，帮你快速看全明星热点的来龙去脉。
            </p>
          </div>

          <div>
            <h3 className="font-serif text-base font-bold text-gold-500">快速导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {anchors.map((a) => (
                <li key={a.id}>
                  <a
                    href={`#${a.id}`}
                    onClick={(e) => { e.preventDefault(); document.getElementById(a.id)?.scrollIntoView({ behavior: "smooth" }); }}
                    className="text-sm text-white/70 transition hover:text-amber2-300"
                  >
                    {a.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-base font-bold text-gold-500">内容合作</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-white/70">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-crimson-400" aria-hidden="true"></i>
                <a href="mailto:contact@readdy.ai" className="transition hover:text-amber2-300" rel="nofollow">
                  contact@readdy.ai
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-crimson-400" aria-hidden="true"></i>
                公众号 · 明星爆料
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center gap-3 border-t border-white/10 pt-6 sm:flex-row sm:justify-between">
          <p className="text-xs text-white/50">
            © {year} 明星爆料 · 本站内容均来自公开渠道，仅供参考
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-white/50">拒绝收录私人录音 / 聊天记录类内容</span>
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-sm text-white/70 transition hover:bg-crimson-500 hover:text-white"
              aria-label="回到顶部"
            >
              <i className="ri-arrow-up-line" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}